import React, { useEffect, useRef } from 'react'
import { createWidget } from '@typeform/embed'

import '@typeform/embed/build/css/widget.css'

import styles from '@components/blocks/typeform_embed.module.scss'

const TypeformEmbed = ({ fields: { typeformLink, height } }) => {
  const typeformRef = useRef(null)

  useEffect(() => {
    createWidget(typeformLink, {
      container: typeformRef.current,
      hideFooter: true,
      hideHeaders: true,
      opacity: 0,
      onSubmit: () => {},
    })
  }, [typeformRef, typeformLink])

  return (
    <div className={styles.typeform_embed}>
      <div
        className={styles.typeform_embed__ref}
        ref={typeformRef}
        style={{ height: height }}
      ></div>
    </div>
  )
}
export default TypeformEmbed
